import { StatelessComponent } from 'react'
import MoneyflowTrackersContainer from 'components/features/pfm/MoneyflowTrackers/MoneyflowTrackersContainer'
import { MoneyflowTrackersOwnProps } from 'components/features/pfm/MoneyflowTrackers/MoneyflowTrackers'
import ModuleWrapper2020 from 'components/features/pfm/ModuleWrapper2020/ModuleWrapper2020'

export type MoneyflowTrackersModuleStateProps = {
  isShown: boolean
}

export type MoneyflowTrackersModuleOwnProps = MoneyflowTrackersOwnProps & {
  title: string
}

type MoneyflowTrackersModuleProps = MoneyflowTrackersModuleStateProps & MoneyflowTrackersModuleOwnProps

const MoneyflowTrackersModule: StatelessComponent<MoneyflowTrackersModuleProps> = (props) => {
  const { isShown, title, type, timeframe } = props

  return isShown
    ? (
      <ModuleWrapper2020 title={ title } card={ false } noPadding forceRoundedCorners>
        <MoneyflowTrackersContainer type={ type } timeframe={ timeframe } />
      </ModuleWrapper2020>
    )
    : null
}

export default MoneyflowTrackersModule
